module.exports = __webpack_public_path__ + "assets/1771b3b8b92dfecea1c13423f523c4e7.png";